import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";

export const FaireDirectSectionErrorFallback = () => (
  <Column align="center" justify="center" style={{ padding: "48px" }}>
    <Typography align="center" variant="displaySSerifRegular">
      <StrictLocalMsg defaultMessage="Oops, something went wrong!" />
    </Typography>
    <Spacer height="2x" />
    <Typography variant="subheadingSansRegular">
      <StrictLocalMsg defaultMessage="Please refresh your page and try again." />
    </Typography>
  </Column>
);
